import * as React from 'react';

import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

const paginationItemVariants = cva('rocco-pagination-item', {
    variants: {
        variant: {
            default: '',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const PaginationItem = React.forwardRef<
    HTMLLIElement,
    OmitStylesComponentProps<'li'> & VariantProps<typeof paginationItemVariants>
>(({ variant, ...props }, ref) => (
    <li ref={ref} className={paginationItemVariants({ variant })} {...props} />
));

PaginationItem.displayName = 'PaginationItem';
